import React from "react";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";

export type LayoutFillParentOverlayProps = BoxProps & {
    opacity?: number;
    backgroundColor?: string;
};

export const testId = "LayoutFillParentOverlay";
const LayoutFillParentOverlay: React.FC<LayoutFillParentOverlayProps> = ({
    children,
    opacity = 0.65,
    backgroundColor = "var(--proda-white-110)",
    sx,
    ...otherProps
}) => {
    return (
        <LayoutFillParentCentered
            data-testid={testId}
            className={testId}
            sx={{
                position: "absolute",
                zIndex: 9999,
                ...sx,
            }}
            {...otherProps}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: backgroundColor,
                    opacity: opacity,
                }}
            />
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    zIndex: 1,
                }}
            >
                {children}
            </Box>
        </LayoutFillParentCentered>
    );
};

export default LayoutFillParentOverlay;
